module.exports = __webpack_public_path__ + "img/no-img.43fab14.svg";